import { useApiMutation } from "./use-api-mutation";

type ResendReturnRequestEmailParams = {
  returnRequestId: string;
  logId: string;
  email: string;
};

export default function useResendReturnRequestEmail(shopId: string) {
  return useApiMutation(
    "post",
    "/super-admin/shops/{shopId}/return-requests/{returnRequestId}/logs/{logId}/resend-email",
    {
      mapVariables: ({
        returnRequestId,
        logId,
        email,
      }: ResendReturnRequestEmailParams) => ({
        params: { path: { shopId, returnRequestId, logId } },
        body: { email },
      }),
    },
  );
}
